<template>
  <div
    class="good-list"
    :v-loading="loading"
  >
    <div class="left">
      <el-select
        v-model="treeType"
        class="tree-type"
        @change="typeChange"
        :disabled="treeTypeDisabled()"
      >
        <el-option
          v-for="item in treeTypeObj"
          :key="item.value||item.id"
          :label="item.label||item.name"
          :title="item.label||item.name"
          :value="item.value||item.id"
        ></el-option>
      </el-select>
      <div
        v-show="treeDisabled()"
        class="tree-dialog"
      ></div>
      <el-tree
        class="tree-style"
        ref="typeTree"
        :data="treeData"
        :node-key="nodeKey"
        :props="defaultProps"
        :current-node-key="currentNodekey"
        @node-click="nodeClick"
        :show-checkbox="treeTypeDisabled()"
        :disabled="treeDisabled()"
        @check-change="checkChange"
      ></el-tree>
    </div>
    <div class="right">
      <div v-if="searchAuto">
        <el-input v-model="searchOther" class="search-input" @keyup.enter.native="searchValue" clearable
                  @clear="clearData">
          <el-button type="primary" slot="append" @click="searchValue">查询</el-button>
        </el-input>
      </div>
      <search-form-template
        v-else
        ref="searchForm"
        :searchOptions="searchOptions"
        @searchSubmit="searchSubmit"
      ></search-form-template>
      <el-table
        class="list"
        v-loading="loading"
        header-row-class-name="table-header"
        :ref="defaultTableOptions.tableName"
        :data="tableData"
        :max-height="maxHeight"
        @selection-change="handleSelectionChange"
        :header-row-style="{height:'28px',lineHeight:'28px'}"
        @row-click="rowClick"
        row-key="id"
        @select="rowSelect"
        @select-all="rowSelect"
        :row-class-name="tableRowClassName"
      >
        <!--多选-->
        <el-table-column
          v-if="isSelect"
          type="selection"
          width="50"
          :selectable="selectEnable"
          reserve-selection
        ></el-table-column>
        <!--索引-->
        <el-table-column
          align="center"
          type="index"
          width="55"
          label="序号"
          reserve-selection
        ></el-table-column>
        <el-table-column
          v-for="(column,index) in (tableOptions.columns||defaultTableOptions.columns)"
          :key="index"
          :class-name="column.class"
          :property="column.prop"
          :label="column.label"
          :align="column.align ||tableOptions.align||defaultTableOptions.align"
          :min-width="column.width || tableOptions.width||defaultTableOptions.width"
          show-overflow-tooltip
          reserve-selection
        >
          <template slot-scope="scope">
            <div :style="{height:'27px',lineHeight:'27px'}">
              <span>{{ scope.row[column.prop] }}
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <div class="fl total-cue">所有记录</div>
        <div class="fl total-cue">{{ page.total }}条</div>
        <!--分页-->
        <el-pagination
          class="tr"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-size="page.pageSize"
          background
          :page-sizes="[10, 15, 20, 30, 40,100,200]"
          layout="sizes, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
      <div
        v-if="isSelect"
        class="btn-box"
      >
        <el-button
          @click="selectSubmit"
          type="primary"
        >确定
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import searchFormTemplate from "../template/searchFormTemplate";
import tableTemplate from "../template/tableTemplate";
import api from "@/config/api";

export default {
  props: {
    // 回填已选过的数据
    toggleSelection: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 页面列表传过来的数据，用于判断是否已被选择
    listTableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    searchAuto: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    isSelect: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    otherParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
    tableOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectUrl: {
      type: Object,
      default: () => {
        return {};
      },
    },
    seleckMainGood: {
      type: Object,
      default: () => {
        return {};
      },
    }
  },
  components: {tableTemplate, searchFormTemplate},
  data() {
    return {
      maxHeight: 320,
      searchOther: null,//商品条码 模糊搜索
      currentNodekey: '',//当前选中的节点
      treeTypeObj: [
        {label: "类别", value: 1},
        {label: "品牌", value: 2},
        {label: "供应商", value: 3},
      ],
      loading: false,
      nodeKey: "id",
      defaultProps: {
        children: "children",
        label: "name",
      },
      searchOptions: {
        labelWidth: "50px",
        simple: [
          {label: "过滤", prop: "otherName", type: "input", isFuzzy: true},
        ],
      },
      treeData: [],
      // 表格信息配置
      defaultTableOptions: {
        tableName: "goodsTable",
        indexShow: true, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "条码",
            prop: "barCode",
            width: "200",
            align: "center",
          },
          {
            label: "品名",
            prop: "goodsName",
            width: "150",
            align: "center",
          },
          {
            label: "助记码",
            prop: "artNo",
            width: "150",
            align: "center",
          },
          // {
          //   label: "规格",
          //   prop: "specs",
          //   width: "150",
          //   align: "center",
          // },
          {
            label: "库存",
            prop: "inventoryNum",
            width: "80",
            align: "center",
          },
          {
            label: "单位",
            prop: "unitName",
            width: "80",
            align: "center",
          },
          {
            label: "进货价",
            prop: "buyPrice",
            width: "100",
            align: "center",
          },
          {
            label: "批发价",
            prop: "tradePrice",
            width: "100",
            align: "center",
          },
          {
            label: "成本价",
            prop: "purchasePrice",
            width: "100",
            align: "center",
          },
          {
            label: "零售价",
            prop: "retailPrice",
            width: "100",
            align: "center",
          },
          {
            label: "配送价",
            prop: "deliveryPrice",
            width: "100",
            align: "center",
          },

        ],
        url: api.archives.goodsInfoIncludeSpecs,
      },
      tableData: [],
      treeType: 1,
      searchParam: {statusList: [10, 30]},
      page: {
        current: 1,
        total: 0,
        pageSize: 10,
      },
      tabelSelectRows: [],
      params: {},
      isSelectMain: false,
    };
  },
  created() {
  },
  watch: {
    otherParam() {
      this.params = this.$utils.deepClone(this.otherParam);
      this.getTableData();
    },
  },
  mounted() {
    if (this.otherParam.goodsCategoryIds) {
      this.$refs.typeTree.setCheckedKeys(this.otherParam.goodsCategoryIds);
      this.getCategoryList(this.otherParam.goodsCategoryIds);
    } else if (this.otherParam.goodsBrandIds) {
      this.treeType = 2;
      this.$refs.typeTree.setCheckedKeys(this.otherParam.goodsBrandIds);
      this.getBrandList(this.otherParam.goodsBrandIds);
    } else {
      this.getCategoryList();
    }
    this.params = this.$utils.deepClone(this.otherParam);
    this.searchOther = this.params.otherName;
    this.$refs.searchForm.formModel.otherName = this.params.otherName;
    this.getTableData();
  },
  methods: {
    clearData() {
      this.getTableData()
    },
    //多选禁用与否
    selectEnable(row, rowIndex) {
      // console.log(row)
      if (row.isSelectMain || row.reSelected) {
        return false;
      } else {
        return true;
      }
    },
    // 子商品中 已选的主商品样式
    tableRowClassName({row, rowIndex}) {
      if (row.isSelectMain || row.reSelected) {
        return 'selected-row';
      }
    },
    treeDisabled() {
      return (
        (!!this.otherParam.goodsCategoryId && this.treeType == 1) ||
        (!!this.otherParam.goodsBrandId && this.treeType == 2) ||
        (!!this.otherParam.supplierId && this.treeType == 3)
      );
    },
    treeTypeDisabled() {
      return (
        (!!this.otherParam.goodsCategoryIds &&
          this.otherParam.goodsCategoryIds.length > 0) ||
        (!!this.otherParam.goodsBrandIds &&
          this.otherParam.goodsBrandIds.length > 0)
      );
    },
    selectSubmit() {
      this.searchClear()// 清空搜索
      this.clearSelection();
      this.$emit("selectSubmit", this.tabelSelectRows);
    },
    //清除选中
    clearSelection() {
      this.$refs[this.defaultTableOptions.tableName].clearSelection();
    },
    // 选中的数据
    rowSelect(selection) {
      this.tabelSelectRows = selection;
    },
    //选中项
    handleSelectionChange(val) {
      // if(val.length>1){
      //   this.$refs.goodsTable.clearSelection();
      //   this.$refs.goodsTable.toggleRowSelection(val.pop());
      // }else{
      // }
      this.selectRow = val;
    },
    searchClear() {
      this.page.current = 1
      this.page.pageSize = 10
      this.treeType = 1
      this.getCategoryList();
      if (this.$refs.searchForm) {
        this.$refs.searchForm.simpleClear()
      }
      this.searchOther = null
      this.searchParam = {};
      this.getTableData({});
    },
    // 节点选中状态发生变化时的回调
    checkChange() {
      if (this.otherParam.goodsCategoryIds) {
        this.params.goodsCategoryIds = this.$refs.typeTree.getCheckedKeys();
      } else if (this.otherParam.goodsBrandIds) {
        this.params.goodsBrandIds = this.$refs.typeTree.getCheckedKeys();
      }
      this.getTableData({});
    },
    // 节点被点击时的回调
    nodeClick(nodeData, node, nodeDom) {
      //console.log(nodeData)
      if (this.treeDisabled()) return;
      this.searchParam = {};
      switch (this.treeType) {
        case 1:
          this.searchParam.goodsCategoryId = nodeData.id;
          break;
        case 2:
          this.searchParam.goodsBrandId = nodeData.id;
          break;
        case 3:
          this.searchParam.supplierId = nodeData.id;
          break;
      }
      this.getTableData(this.searchParam);
    },
    searchSubmit(param) {
      //console.log(param, 'param---------------------------------')
      this.params.otherName = this.$refs.searchForm.formModel.otherName
      this.getTableData(param);
    },
    // 单行点击
    rowClick(row, column, event) {
      // 判断是否重复
      if (this.isSelect) return;
      if (this.listTableData && this.listTableData.length > 0) {
        let isReapt = this.listTableData.some(v => {
          if (v.barCode && row.barCode) {
            return v.barCode == row.barCode || row.isSelectMain
          } else {
            return v.goodsId === row.goodsId || v.id === row.id || row.isSelectMain
          }
        })
        //console.log(isReapt)// 如果为true 则是重复
        if (isReapt) {
          this.$message({
            type: 'warning',
            message: '该商品已被选择，请选择其它商品'
          })
        } else {
          this.$emit("rowCheck", row);
        }
      } else {
        if (row.isSelectMain) {//过滤掉主商品已选
          this.$message({
            type: 'warning',
            message: '该商品已被选择，请选择其它商品'
          })
        } else {
          this.$emit("rowCheck", row);
        }
      }
    },
    typeChange() {
      switch (this.treeType) {
        case 1:
          this.getCategoryList();
          break;
        case 2:
          this.getBrandList();
          break;
        case 3:
          this.getSupplierList();
          break;
      }
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.current = 1;
      this.getTableData();
    },


    // 翻页
    handleCurrentChange(value) {
      this.page.current = value;
      this.getTableData();
    },
    // 搜索
    searchValue() {
      if (this.searchOther) {
        this.getTableData({otherName: this.searchOther})
      } else {
        this.getTableData()
      }
    },
    dealPrivateComData(searchParam) {
      if (searchParam && searchParam.otherName && searchParam.otherName.indexOf('%') == -1) {
        searchParam.otherName = "%" + searchParam.otherName + "%";
      }
      return searchParam
    },

    getData() {
      debugger
      return this.tableData;
    },
    // 获取表格数据
    getTableData(param) {
      const loading = this.$loading({
        lock: true,
        text: '加载中，请稍候...',
        background: 'rgba(255, 255, 255, 0.8)',
        target: document.querySelector('.right')
      });
      let searchParam = {
        pageNumber: this.page.current,
        pageSize: this.page.pageSize,
      };
      searchParam = Object.assign(searchParam, this.searchParam || {}, this.params || {},);
      // if (!searchParam.statusList || searchParam.statusList.length === 0) {
      //   searchParam = Object.assign(searchParam, this.searchParam);
      // }
      //
      searchParam = Object.assign(searchParam, param);
      //console.log(searchParam, 'searchParam---------------------------')
      searchParam = this.dealPrivateComData(searchParam)
      let url = this.defaultTableOptions.url;
      if (this.selectUrl.url) {
        url = this.selectUrl.url;
      }
      this.$axios
        .fetchPost(url + "/page", searchParam)
        .then((data) => {
          if (data.code == 200) {
            loading.close()
            data.data.records.forEach((v, i) => {
              // 多选回显
              if (this.toggleSelection.length > 0) {
                this.$nextTick(() => {
                  this.toggleSelection.forEach(row => {
                    if (row.id === v.id) {
                      //console.log(row)
                      this.$refs.goodsTable.toggleRowSelection(v, true)
                    }
                  })
                })
              }
              if (!this.seleckMainGood || JSON.stringify(this.seleckMainGood) !== '{}') {
                if (v.goodsId == this.seleckMainGood.goodsId || v.id == this.seleckMainGood.id || v.barCode == this.seleckMainGood.barCode) {
                  this.$set(v, 'isSelectMain', true)
                  // data.data.records.splice(i,1)
                }
              }
              // 判断是否已经被选过
              if (this.listTableData && this.listTableData.length > 0) {
                this.listTableData.forEach(item => {
                  if (item.barCode && v.barCode) {
                    if (item.barCode === v.barCode) {
                      this.$set(v, 'reSelected', true)
                    }
                  } else {
                    if (item.goodsId === v.goodsId || item.id === v.id) {
                      this.$set(v, 'reSelected', true)
                    }
                  }
                })
              }
            })
            this.tableData = data.data.records;
            this.page.total = data.data.total;
          } else {
            this.$message({message: data.msg, type: "error"});
          }
        })
        .catch((err) => {
          this.$message({message: "请求失败！", type: "error"});
          loading.close()
        })
    },
    // 商品类别
    getCategoryList(ids) {
      this.$axios
        .fetchPost(api.archives.categoryList + "/list", {})
        .then((data) => {
          this.loading = false;
          if (data.code == 200) {
            if (ids) {
              data.data.map((item) => {
                if (
                  ids.filter((id) => {
                    return id == item.id;
                  }).length == 0
                ) {
                  item.disabled = true;
                } else {
                  item.disabled = false;
                }
              });
            }
            data.data.unshift({name: '全部', id: ''});
            this.treeData = data.data;
          } else {
            this.$message({message: data.msg, type: "error"});
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({message: "请求失败！", type: "error"});
          this.loading = false;
        });
    },
    // 品牌
    getBrandList(ids) {
      this.$axios
        .fetchPost(api.archives.brand + "/list", {})
        .then((data) => {
          this.loading = false;
          if (data.code == 200) {
            if (ids) {
              data.data.map((item) => {
                if (
                  ids.filter((id) => {
                    return id == item.id;
                  }).length == 0
                ) {
                  item.disabled = true;
                } else {
                  item.disabled = false;
                }
              });
            }
            //console.log(data.data);
            this.treeData = data.data;
          } else {
            this.$message({message: data.msg, type: "error"});
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({message: "请求失败！", type: "error"});
          this.loading = false;
        });
    },
    // 供应商
    getSupplierList() {
      this.$axios
        .fetchPost(api.archives.supplier + "/list", {})
        .then((data) => {
          this.loading = false;
          if (data.code == 200) {
            this.treeData = data.data;
          } else {
            this.$message({message: data.msg, type: "error"});
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({message: "请求失败！", type: "error"});
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.good-list {
  padding: 5px;
  height: 390px;
}

.good-list .el-table__body-wrapper {
  overflow-y: auto;
  height: 287px;
}

.good-list .left {
  float: left;
  width: 20%;
  margin-right: 10px;
  height: 450px;
  overflow-y: auto;
  position: relative;
}

.tree-dialog {
  height: 420px;
  width: 90%;
  position: absolute;
  z-index: 10000;
  background: #cccccc57;
}

.good-list .left .tree-type {
  margin-bottom: 10px;
}

.good-list .right {
  float: right;
  position: relative;
  width: calc(80% - 10px);
  height: 450px;
}

.good-list .el-table__row {
  cursor: pointer;
}

.good-list .table-header th,
.good-list .el-table__header {
  height: 30px;
  line-height: 30px;
}

.good-list .btn-box {
  position: unset;
  bottom: 2px;
  width: 100%;
  text-align: center;
  left: 0px;
  z-index: 1000;
  width: 100%;
  margin: 0;
  border: 0;
  padding-bottom: 10px;
  padding-top: 10px;
}

.good-list .right .pagination-box {
  position: unset;
  bottom: 32px;
  left: 0px;
  z-index: 1000;
  background-color: #fff;
  line-height: 32px;
  width: 100%;
}

>>> .el-table .selected-row {
  color: #ccc !important;
}

.tree-style >>> .el-tree-node.is-current {
  color: #666;
  font-weight: 700;
  background-color: #f2f2f2;
}

.search-input {
  width: 280px;
  line-height: normal;
  margin-bottom: 10px;
}

/*搜索后面跟的搜索按钮*/
>>> .el-input-group__append, .el-input-group__prepend {
  background-color: #458cff;
  color: #fff;
  border-color: #458cff;
  font-weight: 700;
}

>>> .el-pagination__editor.el-input {
  width: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/business/goodList.vue